<template>
  <router-link :to="`/actions/${reachout.id}`" class="n-pill" @click.stop>
    <span :class="{ reachoutIconBounced: reachout.status_badge === 'bounced' }">
      <AppIcon :name="reachoutIcon(reachout.type, reachout.sent)" :size="12" />
    </span>
    {{ reachout.first_name }}
    <span
      v-if="reachout.status_badge"
      class="reachoutStatusBadge"
      :class="`reachoutStatusBadge--${reachout.status_badge}`"
    >
      <AppIcon v-if="reachout.status_badge === 'replied'" name="checkmark" :size="10" />
      <span v-else-if="reachout.status_badge === 'deleted'" class="reachoutStatusDot" />
    </span>
  </router-link>
</template>

<script setup lang="ts">
import AppIcon from '../../components/AppIcon.vue'

export interface ReachoutPillData {
  id: string
  type: string
  sent: boolean
  first_name: string
  status_badge?: 'bounced' | 'replied' | 'deleted' | null
}

defineProps<{
  reachout: ReachoutPillData
}>()

const _reachoutIcons: Record<string, [string, string]> = {
  reachout_email: ['email', 'email_outline'],
  reachout_voicemail: ['voicemail', 'voicemail_outline'],
  reachout_phone: ['phone_call', 'phone_call'],
  reachout_linkedin: ['linkedin', 'linkedin'],
}
function reachoutIcon(type: string, sent: boolean): string {
  const pair = _reachoutIcons[type] || ['email', 'email_outline']
  return sent ? pair[0] : pair[1]
}
</script>

<style scoped>
.reachoutIconBounced {
  position: relative;
  color: var(--color-danger, #dc2626);
}
.reachoutIconBounced::after {
  content: '';
  position: absolute;
  top: 50%;
  left: -1px;
  right: -1px;
  height: 1.5px;
  background: var(--color-danger, #dc2626);
  transform: rotate(-45deg);
}

.reachoutStatusBadge {
  display: inline-flex;
  align-items: center;
  margin-left: 2px;
}
.reachoutStatusBadge--replied { color: var(--color-accent); }
.reachoutStatusBadge--deleted { color: var(--color-danger, #dc2626); }

.reachoutStatusDot {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--color-danger, #dc2626);
}
</style>
